//
//
//
//
//
//
//
//
//
//
//

import ExamineList from "./components/ExamineList";
export default {
  components: {
    ExamineList,
  },
  data() {
    return {};
  },
};
